import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { GridConfig } from './GridSizes';
import MediaQueries from './MediaQueries';

function calculateColumnDimension(value, total) {
  const columnValue = (value / total) * 100;
  return `${columnValue}%`;
}

function getColumnDimension(value, viewport) {
  if (Array.isArray(value)) {
    const [cols, total] = value;
    return calculateColumnDimension(cols, total);
  }

  return calculateColumnDimension(value, GridConfig[viewport].columns);
}

const Column = styled.div(
  {
    position: 'relative',
    minHeight: '1px',
    paddingLeft: 0,
    paddingRight: 0,
  },
  ({ cols, offsets, noGutter }) => ({
    width: cols.sm && getColumnDimension(cols.sm, 'sm'),
    marginLeft: offsets.sm && getColumnDimension(offsets.sm, 'sm'),
    paddingLeft: noGutter ? 0 : GridConfig.sm.gutter / 2,
    paddingRight: noGutter ? 0 : GridConfig.sm.gutter / 2,
    [MediaQueries.mdAndUp]: {
      width: cols.md && getColumnDimension(cols.md, 'md'),
      marginLeft: offsets.md && getColumnDimension(offsets.md, 'md'),
      paddingLeft: noGutter ? 0 : GridConfig.md.gutter / 2,
      paddingRight: noGutter ? 0 : GridConfig.md.gutter / 2,
    },
    [MediaQueries.lgAndUp]: {
      width: cols.lg && getColumnDimension(cols.lg, 'lg'),
      marginLeft: offsets.lg && getColumnDimension(offsets.lg, 'lg'),
      paddingLeft: noGutter ? 0 : GridConfig.lg.gutter / 2,
      paddingRight: noGutter ? 0 : GridConfig.lg.gutter / 2,
    },
    [MediaQueries.xl]: {
      width: cols.xl && getColumnDimension(cols.xl, 'xl'),
      marginLeft: offsets.xl && getColumnDimension(offsets.xl, 'xl'),
      paddingLeft: noGutter ? 0 : GridConfig.xl.gutter / 2,
      paddingRight: noGutter ? 0 : GridConfig.xl.gutter / 2,
    },
  }),
);

Column.defaultProps = {
  cols: {},
  offsets: {},
  noGutter: false,
};

Column.propTypes = {
  cols: PropTypes.shape({
    sm: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
    md: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
    lg: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
    xl: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  }),
  offsets: PropTypes.shape({
    sm: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
    md: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
    lg: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
    xl: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  }),
  noGutter: PropTypes.bool,
};

export default Column;
